import { createSelector } from 'reselect';
import { CURIOSO_TYPES_MAP } from '../../data/constants';

/**
 *  Heplper function for generate for qugmentation corresponding layers name
 * e.g. ".aug .cat .eyes .sunglasses"
*/
const generateLayerName = (CuriosoType, category, itemName) =>
  `.aug .${CURIOSO_TYPES_MAP[CuriosoType]} .${category} .${itemName.slice(0, -7)}`;

/**
  * Selector for transforming Augmentation data to arrays of layers that should be visible/hidden
  * accorging to aplliyed augmentations
*/
export default createSelector(
  state => state.curiosoReducer.augmentations,
  state => state.curiosoReducer.curioso.skin,
  (augmentation, CuriosoSkin) => {
    const hideLayers = [];
    // get layers that should be visible and hide
    Object.keys(augmentation).forEach((categoryName) => {
      const category = augmentation[categoryName];
      Object.keys(category).forEach((itemName) => {
        if (!category[itemName]) {
          // augmentation is NOT applied - HIDE corresponding layer
          hideLayers.push(generateLayerName(CuriosoSkin, categoryName, itemName));
        }
      });
    });
    return {
      hideLayers,
    };
  },
);
